import { ReactNode } from "react";

import Modal from "components/modal/Modal";
import { useRootStore } from "store";
import ModalFooter from "components/modal/ModalFooter";

type Props = {
  onDismiss: () => void;
  onConfirm: () => void;
  children: ReactNode;
  isLoading?: boolean;
};

export default function UploadConfirmationModal({
  onDismiss,
  onConfirm,
  children,
  isLoading
}: Props) {
  const { customerName } = useRootStore(
    (state) => state.customers.workingCustomer
  );

  return (
    <Modal
      onDismiss={onDismiss}
      modalTitle="upload confirmation modal"
      size="sm"
      header={
        <div className="mb-5">
          <h2 className="fpx-20 fw-lighter">
            Ladda upp fil till:{" "}
            <span className="fw-bolder">{customerName}</span>
          </h2>
        </div>
      }
      footer={
        !isLoading && (
          <ModalFooter
            onConfirm={onConfirm}
            onCancel={onDismiss}
            confirmText="Bekräfta"
            actionsClassName="mt-5"
          />
        )
      }
    >
      {children}
    </Modal>
  );
}
